// Lib
import { values } from 'lodash/fp';

// Utils
import { createShallowSelector } from '../../../utils/milanoteReselect/milanoteReselect';

export const getBoardSummariesFetched = (state) => state.getIn(['app', 'boardSummaries', 'fetched']);
export const getBoardSummariesMapSelector = (state) => state.getIn(['app', 'boardSummaries', 'summaries']);
export const getBoardSummariesArraySelector = createShallowSelector(getBoardSummariesMapSelector, values);
